import {
    endOfMonth as fnsEndOfMonth,
    format,
    getDate,
    Locale,
    isFuture,
    isMatch,
    isSameDay,
    startOfMonth as fnsStartOfMonth,
    subDays,
} from 'date-fns';
import {et, enUS, fi, lt, lv, ru, sv, pl, vi, ja} from 'date-fns/locale';

import {Language} from './label-store';
import {DateRange} from 'react-day-picker';

export const formatToDayAndMonth = (localDate: string): string => format(new Date(localDate), 'dd.MM');
export const formatToDayAndMonthWithDateInput = (localDate: Date | null | undefined): string | undefined => localDate !== undefined || localDate !== null ? format(localDate as Date, 'dd.MM') : undefined;
export const formatToDayMonthAndYear = (localDate: string): string => format(new Date(localDate), 'dd.MM.yyyy');
export const formatToDayMonthAndYearWithDateInput = (localDate: Date | null | undefined): string | undefined => localDate !== undefined || localDate!== null ? format(localDate as Date, 'dd.MM.yyyy') : undefined;
export const formatToYearMonthAndDayWithDateInput = (localDate: Date | null | undefined): string | undefined => localDate !== undefined || localDate!== null ? format(localDate as Date, 'yyyy-MM-dd') : undefined;
export const formatToYearAndMonthAndDayWithDateInput = (localDate: Date): string => format(localDate as Date, 'yyyy-MM-dd');
export const todayAsISOString = (): string => format(new Date(), 'yyyy-MM-dd');
export const isValidLocalDate = (localDate: string | undefined): boolean => localDate !== undefined && isMatch(localDate, 'yyyy-MM-dd');
export const isDateInFuture = (localDate: Date): boolean => isFuture(localDate);
export const isVacationStartInFuture = (localDate: Date | null | undefined): boolean | undefined => localDate !== undefined || localDate !== null ? isFuture(localDate as Date) : undefined;
export const isDateInFutureForModal = (localDate: Date): boolean => isFuture(localDate);
export const formatToDayAndMonthMinusSixDays = (localDate: string): string => format(subDays(new Date(localDate), 6), 'dd.MM');
export const startOfMonth = isSameDay(fnsStartOfMonth(new Date()), new Date());
export const endOfMonth = isSameDay(fnsEndOfMonth(new Date()), new Date());
export const isEvenDate = (localDate: Date): boolean => getDate(localDate) % 2 === 0;
export const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const isToday = (localDate: string): boolean => localDate === format(new Date(), 'yyyy-MM-dd');
export const getLocaleFromLanguage = (lang: Language | undefined): Locale | undefined => {
    switch (lang) {
        case 'et':
            return et;
        case 'en':
            return enUS;
        case 'fi':
            return fi;
        case 'lt':
            return lt;
        case 'lv':
            return lv;
        case 'ru':
            return ru;
        case 'sv':
            return sv;
        case 'pl':
            return pl;
        case 'ja':
            return ja;
        case 'vi':
            return vi;
        default:
            return undefined;
    }
};

export const rangeFromPeriodId = (periodId: string): DateRange => {
    const [toDateString, length] = periodId.split('_');
    const to = new Date(toDateString);
    const from = new Date(to);

    from.setDate(from.getDate() - parseInt(length) + 1);

    return {from, to} as DateRange;
};

export const periodIdFromRange = (range: DateRange): string => {
    const diff= range.to!.getTime() - range.from!.getTime();
    const periodLength = Math.round(diff / (24*60*60*1000)) + 1;

    return formatToYearMonthAndDayWithDateInput(range.to) + '_' + periodLength;
};

export const formatDateRange = (range: DateRange): string => {
    const {from, to} = range;

    return formatToDayMonthAndYearWithDateInput(from) + ' - ' + formatToDayMonthAndYearWithDateInput(to);
};
